module.exports = __webpack_public_path__ + "img/fsg_basketball.166c9e3f.svg";